import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative inline-flex items-center py-5px px-2.5 group mr-5px mb-5px bg-next-gray-md-darker hover:bg-white hover:shadow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    (!_ctx.$attrs.readonly)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          tabindex: "1",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('remove', $event)), ["stop","prevent"])),
          class: "hidden cursor-pointer fa fa-times group-hover:block text-next-orange p-0 ml-2"
        }))
      : _createCommentVNode("", true)
  ]))
}